var _rect, _mask, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRussianFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1145_22986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1145_22986",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 7,
    mask: "url(#path-2-inside-1_1145_22986)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1145_22986)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6666H22V5.33331H0V10.6666Z",
    fill: "#0C47B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H22V10.6667H0V16Z",
    fill: "#E53B35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussianFlag);
export default __webpack_public_path__ + "static/media/russianFlag.2792a7a85da4f0d21ae22edc3502e1f3.svg";
export { ForwardRef as ReactComponent };